import SHSkeleton, {
  SHSkeletonProps,
} from "@components/design-systems/sh-skeleton";

export const SHDividerSkeleton = ({ ...others }: SHSkeletonProps) => {
  return <SHSkeleton {...others} height={1} width="100%" />;
};
